<template>
  <div class="full-container">
    <Welcome></Welcome>
    <!-- </v-img> -->
    <WhatIDo></WhatIDo>
    <ProjectList></ProjectList>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProjectList from '@/components/normal/ProjectList'
import Welcome from '@/components/perfil/welcome'
import WhatIDo from '@/components/perfil/whatIDo'

export default {
  components: {
    ProjectList,
    Welcome,
    WhatIDo
  },
  head() {
    return {
      title: {
        inner: 'Inicio'
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} home page`,
          id: 'desc'
        }
      ]
    }
  },
  computed: mapState('app', ['appTitle'])
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.full-container {
  width: 100%;
}
</style>
